<div *ngIf="data && totalRecords > 0">

    <div class="filter-actions">
        <button class="btn-outlined" type="button" (click)="clearFilters()">
            <fa-icon [icon]="faFilterCircleXmark"></fa-icon>
            Clear Filters
        </button>
    </div>
    <table class="ts-table">
        <thead>
            <tr>
                <ng-container *ngFor="let column of columns; let i = index">
                    <th *ngIf="column.isDisplayed" class="header-vertical-border"
                        [ngClass]="{'medium-column': i == 0 && showTradeOrders, 'text-right-numeric': column.type === TableColumnType.number || column.type === TableColumnType.currency || column.key === 'accountId'}">
                        <div class="header-content">
                            <div class="header-title" [ngClass]="{'header-title-left': column.type !== TableColumnType.number && column.type !== TableColumnType.currency && column.key !== 'accountId'}">
                                {{column.displayName}}
                            </div>
                            <div *ngIf="column.isFilterEnabled" class="filter-container" [ngClass]="{'filter-left': column.type !== TableColumnType.number && column.type !== TableColumnType.currency && column.key !== 'accountId'}">
                                <input #filter id="{{column.key}}-filter" class="filter"
                                    [ngClass]="{'text-right-numeric': column.type === TableColumnType.number || column.type === TableColumnType.currency || column.key === 'accountId'}"
                                    [type]="column.type === TableColumnType.number ? 'number' : 'text'"
                                    [min]="column.type === TableColumnType.number ? 0 : null"
                                    (input)="applyFilters()" size="8" placeholder="Filter">
                            </div>
                        </div>
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let element of pagedData">
                <tr class="element-row" (click)="toggleRow(element)" [class.expanded-row]="element.expanded">
                    <ng-container *ngFor="let column of columns; let i = index">
                        <td *ngIf="column.isDisplayed"
                            [ngClass]="{'medium-column': i == 0 && showTradeOrders, 'text-right-numeric': column.type === TableColumnType.number || column.type === TableColumnType.currency || column.key === 'accountId'}">
                            <fa-icon *ngIf="i == 0 && showTradeOrders && !element?.expanded" [icon]="faPlus"></fa-icon>
                            <fa-icon *ngIf="i == 0 && showTradeOrders && element?.expanded" [icon]="faMinus"></fa-icon>
                            <div [ngClass]="{'font-weight-bold': column.isBoldText}" [ngSwitch]="column.type">
                                <div *ngSwitchCase="TableColumnType.text">
                                    {{element[column.key]}}
                                </div>
                                <div *ngSwitchCase="TableColumnType.number">
                                    {{element[column.key] | number: '1.0-0'}}
                                </div>
                                <div *ngSwitchCase="TableColumnType.currency">
                                    {{element[column.key] | currency:'USD':'symbol':'1.2-2'}}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                </tr>
                <tr class="detail-row" *ngIf="showTradeOrders && element.expanded">
                    <td [attr.colspan]="getDisplayedColumnKeys().length">
                        <div class="element-detail">
                            <app-allocation-orders-table
                                [data]="element">
                            </app-allocation-orders-table>
                            <div class="footer-container">
                                <button class="btn-primary" *ngIf="!isAccountFullAllocated(element.orders)"
                                    [disabled]="!(checkIfAnyOrderChecked(element) && checkIfAnyQuantityToAllocate(element))"
                                    (click)="allocateSelected(element)">Next</button>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>

    <app-paginator [length]="filteredTotalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
        (page)="pageChangeEvent($event)" [pageSizeOptions]="[10, 25, 50, 100, 500]"></app-paginator>
</div>
<app-empty-state *ngIf="totalRecords == 0"
    [icon]="faScaleBalanced"
    headline="No allocated trades"
    hint="No trades are available to allocate for this selection."></app-empty-state>
